import { Type } from "class-transformer";
import { IsInt, IsNumber, IsOptional, IsString, Min } from "class-validator";

import { IWeightPullClassSetup } from "./show-weight-pull-setup.interface";

export class WeightPullClassSetupDto implements IWeightPullClassSetup {
  @IsString()
  weight_class: string;

  @IsOptional()
  @Type(() => Number)
  @IsNumber()
  @Min(0)
  starting_weight?: number;

  @IsOptional()
  @Type(() => Number)
  @IsNumber()
  @Min(0)
  block_weight?: number;

  @IsOptional()
  @Type(() => Number)
  @IsInt()
  @Min(0)
  block_drop?: number;
}
